/*
    CTC - Modeller Data 1.4.16.0
    DataSet Date: 17/02/2026
*/

var ctcProductChargesJSON = '';
var ctcTaxDetailsJSON = '';
var ctcTaxInfoJSON = '';

ctcProductChargesJSON = { "productCharge":
    { "tiers": [
        {
            "maxThreshold": "24999.99",
            "rate": "0.3"
        }, {
            "maxThreshold": "49999.99",
            "rate": "0.3"
        }, {
            "maxThreshold": "99999.99",
            "rate": "0.3"
        }, {
            "maxThreshold": "249999.99",
            "rate": "0.2"
        }, {
            "maxThreshold": "499999.99",
            "rate": "0.15"
        }, {
            "maxThreshold": "749999.99",
            "rate": "0.15"
        }, {
            "maxThreshold": "999999.99",
            "rate": "0.125"
        }, {
            "maxThreshold": "9999999999.99",
            "rate": "0.1"
        }
    ]}
}

ctcTaxDetailsJSON =
{
   "taxDetails":[
      {
         "region":"UK",
         "personalAllowance":"12570",
         "personalAllowanceLimit":"100000",
         "rates":[
            {
      "name":"personal allowance",
               "type":"allowance",
               "rate":"0",
               "upperThreshold":"12570"
            },
            {
               "name":"basic",
      "type":"standard",
               "rate":"20",
               "upperThreshold":"50270"
            },
            {
               "name":"higher",
      "type":"standard",
               "rate":"40",
               "upperThreshold":"137710"
            },
            {
               "name":"additional",
      "type":"standard",
               "rate":"45",
               "upperThreshold":"999999999999"
            }
         ]
      },
      {
         "region":"Scotland",
         "personalAllowance":"12570",
         "personalAllowanceLimit":"100000",
         "rates":[
            {
      "name":"personal allowance",
               "type":"allowance",
               "rate":"0",
               "upperThreshold":"12570"
            },
            {
      "name":"starter",
               "type":"standard",
               "rate":"19",
               "upperThreshold":"16537"
            },
            {
               "name":"basic",
      "type":"standard",
               "rate":"20",
               "upperThreshold":"29525"
            },
            {
               "name":"intermediate",
      "type":"standard",
               "rate":"21",
               "upperThreshold":"43660"
            },
            {
               "name":"higher",
      "type":"standard",
               "rate":"42",
               "upperThreshold":"75000"
            },
   {
               "name":"advanced",
      "type":"standard",
               "rate":"45",
               "upperThreshold":"137710"
            },
            {
               "name":"additional",
      "type":"standard",
               "rate":"48",
               "upperThreshold":"999999999999"
            }
         ]
      }
   ],
    "nationalInsurance": [
        {
            "type": "primaryThreshold",
            "band": "12570",
            "rate": "0"
        },
  {
          "type":"upperEarningsLimit",
          "band":"50270",
         "rate":"8.0"
  },
  {
         "type":"aboveUpperEarningsLimit",
          "band":"999999999999",
         "rate":"2.0"
  }
   ],
   "fcaRates": [
       {
            "effectiveDate" : "2021-04-06",
            "inflationRate" : "2.0",
            "AIR" : "-2.6"
       },
       {
            "effectiveDate" : "2023-04-06",
            "inflationRate" : "2.0",
            "AIR" : "-0.2"
       },
       {
            "effectiveDate" : "2024-04-06",
            "inflationRate" : "2.0",
            "AIR" : "0.6"
       },
       {
            "effectiveDate" : "2025-04-06",
            "inflationRate" : "2.0",
            "AIR" : "1.0"
       },
       {
            "effectiveDate" : "2026-04-06",
            "inflationRate" : "2.0",
            "AIR" : "1.4"
       }
   ]
}
export { ctcProductChargesJSON, ctcTaxDetailsJSON, ctcTaxInfoJSON };



// WEBPACK FOOTER //
// ./src/calculator/ctcProductData.js